import { Button } from "antd";
import { ColumnsType } from "antd/es/table";
import { useCallback, useEffect } from "react";
import EyeIcon from "../../../assets/icons/EyeIcon";
import { addKeyInArray, pathLink } from "../../../helpers/siteConfig";
// import useModal from "../../../hooks/useModal";
import { Link, useLocation } from "react-router-dom";
import {
  getAllSupplierAsync,
  getCountSupplierAsync,
} from "../../../store/features/NP/supplier/supplierAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { CustomTableProps } from "../../../types";
import {
  GetAllSupplierData,
  SupplierGetAllParams,
} from "../../../types/redux/NP/supplier";
import CustomTable from "../../common/CustomTable";
import EditIcon from "../../../assets/icons/EditIcon";
// import SupplierUser from "./SupplierUser";

type Props = {
  keyword?: string;
} & CustomTableProps;

export default function SupplierTable({
  keyword = "",
  page,
  limit,
  isFirstPage,
  handlePagination,
  handleSetFirstPage,
}: Props) {
  const location = useLocation();
  const dispatch = useAppDispatch();
  // const { limit, page, handlePagination } = useTable();
  // const { open, toggle, handleOpen } = useModal();
  const { login } = useAppSelector((state) => state.login);
  const { loading, allSupplier, supplierCount } = useAppSelector(
    (state) => state.supplier
  );
  const path = pathLink(location.pathname, 1);

  const columns: ColumnsType<GetAllSupplierData> = [
    {
      title: "Supplier Name",
      dataIndex: "supplierName",
    },
    {
      title: "Supplier Address",
      dataIndex: "supplierAddress",
    },
    // {
    //   title: "Wallet Number",
    //   dataIndex: "walletNumber",
    //   render: (val) => (val ? val : "-"),
    // },
    {
      title: "Contact No",
      dataIndex: "contactNumber",
      // render: (val) =>
      //   val?.length ? val?.map((el: string) => <p key={el}>{el}</p>) : "N/A",
      render: (val: unknown) => {
        if (!Array.isArray(val) || !val.length) return "N/A";
        const uniqueContacts = Array.from(new Set(val as string[]));
        return uniqueContacts.map((el: string) => <p key={el}>{el}</p>);
      },
    },
    {
      title: "Action",
      align: "center",
      render: (val: GetAllSupplierData) => {
        return (
          <>
            <Link to={`/${path}/supplier/update-supplier/${val?._id}`}>
              <Button icon={<EditIcon />} />
              {/* <Button type="primary" icon={<EditFilled />} /> */}
            </Link>

            <Link
              to={`/${path}/supplier/${val?._id}?name=${val?.supplierName}`}
              className="ml-4"
            >
              {/* <Button
                // onClick={() =>
                //   handleOpen({
                //     type: "LOG",
                //     data: val,
                //   })
                // }
                // className="accent-text"
                // type="text"
                icon={<EyeIcon />}
              /> */}

              <Button icon={<EyeIcon />} />
            </Link>
          </>
        );
      },
    },
  ];

  const supplierData = useCallback(() => {
    const params: SupplierGetAllParams = {
      limit: limit,
      skip: limit * (page - 1),
    };

    const searchParams: SupplierGetAllParams = {
      supplierName: keyword,
    };

    if (login?.role === "region" || login?.role === "finance") {
      params.region = login?.region;
      searchParams.region = login?.region;
    }

    dispatch(
      getAllSupplierAsync({
        params: keyword ? searchParams : params,
      })
    );

    dispatch(
      getCountSupplierAsync({
        params: keyword ? searchParams : params,
      })
    );
  }, [dispatch, keyword, limit, login?.region, login?.role, page]);

  useEffect(() => {
    supplierData();
  }, [supplierData]);

  useEffect(() => {
    if (keyword && isFirstPage) {
      handlePagination(1, 10);
      handleSetFirstPage(false);
    }
  }, [handlePagination, handleSetFirstPage, isFirstPage, keyword]);

  return (
    <>
      {/* {open.type === "LOG" && (
        <SupplierUser
          title="Supplier User List"
          open={open.open}
          data={open?.data}
          handleClose={toggle}
        />
      )} */}
      <CustomTable<GetAllSupplierData>
        loading={loading}
        total={supplierCount}
        page={page}
        handlePagination={handlePagination}
        columns={columns}
        dataList={addKeyInArray(allSupplier)}
        isPagination={keyword ? false : true}
      />
    </>
  );
}
